import { last } from 'lodash';
import ContactContext from '@/contact/models/ContactContext';
import { DossierId } from '@/dossier/models/AbstractDossier';
import Identity from '@/general/models/Identity';
import { DossierMediaContext } from '@/general/models/MediaContext';
import MediaFile from '@/general/models/MediaFile';
import ChatType from '@/shared/constants/ChatType';
import Language from '@/shared/constants/Language';
import Permission from '@/shared/constants/Permission';
import DossierContactTarget from '@/shared/models/DossierContactTarget';
import ChatPage from '../constants/ChatPage';
import Chat from './Chat';
import ChatContext from './ChatContext';

export default class ExternalChatContext extends ChatContext {
  mediaFiles: Array<MediaFile> = [];
  targets: Array<DossierContactTarget> = [];
  media: DossierMediaContext | null = null;

  constructor(
    chat: Chat,
    public contactContext: ContactContext,
    currentUser: Identity,
    dossierId: DossierId,
  ) {
    super(ChatType.EXTERNAL, chat, currentUser, dossierId);
    this.targets = contactContext.wrapTargets(last(chat.messages)?.targets ?? []);
  }

  canWrite(): boolean {
    return this.currentUser.hasPermission(Permission.WRITE_IN_CHATS);
  }

  canSend(): boolean {
    return this.targets.length > 0 && (this.page === ChatPage.MEDIA ? this.mediaFiles.length > 0 : super.canSend());
  }

  resetPage(): void {
    this.clearMedia();
    super.resetPage();
  }

  getLanguages(): Array<Language> {
    if (this.targets.length === 0) return super.getLanguages();
    return [...new Set(this.targets.map(t => t.contact.customer.language))];
  }

  clearMedia(): void {
    this.mediaFiles = [];
  }

  free(): void {
    super.free();
    this.media?.free();
  }
}